<ng-container *ngIf="(state$ | async) as state">
  <span class="autosave-indicator" aria-live="polite" *ngIf="state !== 'idle'">
    <ng-container [ngSwitch]="state">
      <ng-container *ngSwitchCase="'saving'">
        <mat-icon class="hs-chat-spin">autorenew</mat-icon>
        <span class="autosave-text">Saving...</span>
      </ng-container>

      <ng-container *ngSwitchCase="'saved'">
        <mat-icon class="autosave-saved">check_circle</mat-icon>
        <span class="autosave-text">Saved</span>
      </ng-container>

      <ng-container *ngSwitchCase="'error'">
        <mat-icon class="autosave-error">warning</mat-icon>
        <span class="autosave-text">Unsaved changes</span>
      </ng-container>
    </ng-container>
  </span>
</ng-container>
